import { StandardProps } from "@/components/componentMap";
import styles from "./StoryPlaceholder.module.scss";

export function StoryPlaceholder({
  configProps,
}: Pick<StandardProps, "configProps">) {
  return (
    <div
      className={styles.placeholder}
      data-component="StoryPlaceholder"
      style={{
        height: Number(configProps?.height || 40),
      }}
    >
      {String(configProps?.label || "Slot")}
    </div>
  );
}
